import { render, staticRenderFns } from "./FooterFixo.vue?vue&type=template&id=078b9612&"
import script from "./FooterFixo.vue?vue&type=script&lang=js&"
export * from "./FooterFixo.vue?vue&type=script&lang=js&"
import style0 from "./FooterFixo.vue?vue&type=style&index=0&id=078b9612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports